import { alpha, keyframes, type SxProps, type Theme } from "@mui/material/styles";

const rise = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const stack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: { xs: theme.spacing(2.5), md: theme.spacing(3.5) },
  py: { xs: 1, md: 2 },
  animation: `${rise} 0.45s ease both`,
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
});

export const heading: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: theme.spacing(1.25),
  maxWidth: 620,
  mx: "auto",
});

export const successBadge: SxProps<Theme> = (theme) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(0.75),
  px: 1.5,
  py: 0.625,
  borderRadius: 5,
  bgcolor: alpha(theme.palette.success.main, 0.1),
  color: "success.main",
  fontSize: "0.75rem",
  fontWeight: 700,
});

export const title: SxProps<Theme> = {
  fontSize: { xs: "1.25rem", md: "1.75rem" },
  fontWeight: 800,
  lineHeight: 1.5,
};

export const subtitle: SxProps<Theme> = {
  fontSize: { xs: "0.8125rem", md: "0.9375rem" },
  color: "text.secondary",
  lineHeight: 1.9,
};

export const connectedCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 3,
  boxShadow: theme.shadows[3],
  p: { xs: 2, md: 3 },
  maxWidth: 820,
  width: "100%",
  mx: "auto",
});

export const footer: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(1),
});

export const skipButton: SxProps<Theme> = {
  fontWeight: 700,
  color: "text.secondary",
};

export const primaryButton: SxProps<Theme> = {
  minWidth: 220,
  minHeight: 48,
};

export const laterHint: SxProps<Theme> = {
  fontSize: "0.71875rem",
  color: "text.secondary",
};
